import React from 'react';
import { Box, Button } from '@mui/material';
import FormModal from 'components/FormModal/FormModal';
import CreateNewHandlerForm from './CreateNewHandlerForm';
import { CreateNewHandlerModalProps } from './types';

const CreateNewHandlerModal: React.FC<CreateNewHandlerModalProps> = ({
    isOpen,
    onCancel,
    onSave,
    form,
    errors,
    handlerTypeOptions,
    onFieldChange
}) => (
    <FormModal
        isOpen={isOpen}
        onClose={onCancel}
        title="Create New Handler"
        maxWidth={1150}
        footer={(
            // Bleeds through FormModal's own footer padding (10px 28px) to repaint the
            // whole footer strip in this feature's background, without touching
            // FormModal's shared .footer rule.
            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                gap: 2,
                flex: 1,
                margin: '-10px -28px',
                padding: '10px 28px',
                backgroundColor: '#ffffff',
                borderTop: '1px solid #f1f5f9'
            }}>
                <Button onClick={onCancel} sx={{ color: '#6b7280', fontWeight: 600 }}>
                    CANCEL
                </Button>
                <Button
                    onClick={onSave}
                    variant="contained"
                    sx={{
                        backgroundColor: '#39ACE7',
                        fontWeight: 600,
                        minWidth: 96,
                        minHeight: 32,
                        borderRadius: '6px',
                        py: 0.5,
                        '&:hover': { backgroundColor: '#2c8ebb' }
                    }}
                >
                    SAVE
                </Button>
            </Box>
        )}
    >
        <CreateNewHandlerForm
            form={form}
            errors={errors}
            handlerTypeOptions={handlerTypeOptions}
            onFieldChange={onFieldChange}
        />
    </FormModal>
);

export default CreateNewHandlerModal;
